// extracted by mini-css-extract-plugin
module.exports = {"loaderSpinner":"loader_loaderSpinner__zp7oS","spin":"loader_spin__Utkay","animateFadeIn":"loader_animateFadeIn__fzX8r","fadeIn":"loader_fadeIn___Y5hT"};